import React from "react";
import PropTypes from "prop-types";
import "components/ListView/ListView.css";

function ListView({ children, className: customClassName = "" }) {
  return (
    <div className={"list-view__wrapper " + customClassName}>
      {children &&
        children.map((element) => {
          return (
            <div className="list-view__item" key={element.key}>
              {element}
            </div>
          );
        })}
    </div>
  );
}

ListView.propTypes = {
  children: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string,
};

export default ListView;
